export enum ThemeActionTypes {
  TOGGLE_COLLAPSE = '@theme/collapse/toggle',
}
